import { useAuth } from "@climatepartner/hooks";
import { getServiceUrls, mapServiceUrlsByAccess } from "@climatepartner/utils";

export interface ServiceLink {
    id: string;
    url: string;
    userHasAccess?: boolean;
}

export const useServices = () => {
    const { hasPermission } = useAuth();
    const serviceUrls = getServiceUrls({ env: window.$cp.environment, userHasPermission: hasPermission });
    const mappedServices = mapServiceUrlsByAccess(serviceUrls);

    return mappedServices;
};
